import Utils from 'nova-tn-frontend/source/scripts/modules/Utils';
import { register, toggleFullscreen } from '../services/players';

const PlayerGeneral = {
  Init() {
    const rteHeroVideo = $('.c-player.-eyecatcher');
    const playlistPlayer = $('.js-playlistplayer');
    const playlistPlayerHeight = $(
      '.js-playlistplayer .c-time-duration-wrapper'
    ).height();

    register((data = {}) => {
      const playerId = data?.customData?.videoID;
      const playerShort = data?.customData?.embed?.short;
      const playerWrapperById = $(`[data-video-id='${playerId}']`);

      const playerElement = $('[data-video-id="' + playerId + '"]');
      const isHeroPlayer = $('[data-video-id="' + playerId + '"]').closest(
        '.c-player.-eyecatcher'
      ).length;
      // eslint-disable-next-line default-case
      switch (data.eventName) {
        case 'play':
          /**
           * Handle fullscreen state when a new video loads (ad or content).
           * The player may retain the fullscreen state from the previous video.
           */
          if (Utils.parentIsInFullscreen() && !Utils.IsResponsive() && !Utils.isTouchDevice() && !Utils.isTouchDevice()) {
            toggleFullscreen(playerId, true);
          }
          break;
        case 'enterfullscreen':
          $('body').addClass('-fake-fullscreen');

          if (playerWrapperById) {
            playerWrapperById.addClass('is-fullscreen');
          } else {
            $(`[data-short='${playerShort}']`).addClass('is-fullscreen');
          }

          // Keeping the old logic for the cinema player (fullscreen now)
          // This bunch of code must be done due to hardcoded iframe inline styles which are hard to override
          if (Utils.isTouchDevice() && playerId) {
            if (isHeroPlayer) {
              playerElement
                .parents('.row')
                .addClass('c-player-cinema-expanded');

              if (playlistPlayer.length) {
                rteHeroVideo
                  .parents('.row')
                  .css(
                    'padding-top',
                    'calc(56.25% + 40px + ' + playlistPlayerHeight + 'px)'
                  );
              }
            }

            playerElement
              .parents('.c-player')
              .addClass('is-fullscreen')
              .find('.detach-container > div')
              .css({
                height: '100%',
                position: 'static',
                'padding-top': '0',
              });

            // $('body').addClass('player-in-cinema');
          }

          $('meta[name=viewport]').attr(
            'content',
            'width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover'
          );

          if ($('.js-tn-live-player').length) {
            $('.c-player').addClass('is-fullscreen');
          }
          break;
        case 'exitfullscreen':
        case 'ended':
          if (!data?.eventData.type || data?.eventData?.type !== 'adend') {
            $('body').removeClass('-fake-fullscreen');
            $('[data-video-id]').removeClass('is-fullscreen');
          }

          if (playerId) {
            if (isHeroPlayer) {
              rteHeroVideo
                .parents('.row')
                .removeClass('c-player-cinema-expanded');

              if (playlistPlayer.length) {
                rteHeroVideo.parents('.row').css(
                  {
                    'padding-top': '0',
                  },
                  0
                );
              }
            }

            playerElement
              .parents('.c-player')
              .removeClass('is-fullscreen')
              .find('.detach-container > div')
              .css('height', '0')
              .css('position', 'relative')
              .css('padding-top', '56.25%');
          }

          if ($('.js-tn-live-player').length) {
            $('.c-player').removeClass('is-fullscreen');
          }

          $('meta[name=viewport]').attr(
            'content',
            'width=device-width, initial-scale=1.0, maximum-scale=1'
          );
          break;
      }
    });
  },
};

export default PlayerGeneral;
